import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string,
  data: PropTypes.array,
  fetchMoreData: PropTypes.bool,
  getData: PropTypes.func,
  loading: PropTypes.node,
  pageSize: PropTypes.number,
  reset: PropTypes.bool,
  userAction: PropTypes.bool,
};

const defaultProps = {
  className: '',
  data: [],
  fetchMoreData: true,
  getData: () => {},
  loading: null,
  pageSize: 25,
  reset: false,
  userAction: false,
};

const withInfiniteScroll = Wrapper => {
  class Enhanced extends Component {
    constructor() {
      super();
      this.state = {
        page: 0,
        data: [],
        loadingState: true,
      };
      this.hasMoreItems = true;
      this.loadMoreItems = this.loadMoreItems.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
      this.loadMoreItems();
    }

    componentDidUpdate(prevProps) {
      const nextProps = this.props;
      if (nextProps === prevProps) return;
      if (
        nextProps.userAction ||
        (nextProps.reset &&
          !this.state.loadingState &&
          prevProps.fetchMoreData &&
          nextProps.fetchMoreData &&
          nextProps.data.length !== prevProps.data.length)
      ) {
        this.setState(
          {
            page: 0,
            data: [],
          },
          () => this.loadMoreItems()
        );
      }
      if (nextProps.data && !nextProps.userAction) {
        this.setState({
          data: nextProps.data,
        });
      }
    }

    loadMoreItems() {
      const { fetchMoreData, getData, pageSize } = this.props;
      const { page, data } = this.state;

      if (fetchMoreData) {
        this.setState({ loadingState: true }, async () => {
          const dataReceived = await getData(page, pageSize);
          this.hasMoreItems = dataReceived.length >= pageSize;

          this.setState({
            data: data.concat(dataReceived),
            page: page + 1,
            loadingState: false,
          });
        });
      }
    }

    handleScroll(e) {
      if (
        e.target.scrollHeight - e.target.scrollTop <
          e.target.clientHeight + 30 &&
        !this.state.loadingState &&
        this.hasMoreItems
      ) {
        this.loadMoreItems();
      }
    }

    render() {
      const { data, loadingState } = this.state;
      const { loading, className, ...otherProps } = this.props;
      return (
        <div
          className={`rp-infinite-scroll ${className}`}
          onScroll={this.handleScroll}
        >
          <Wrapper
            {...otherProps}
            data={data}
            loading={loadingState ? loading : null}
          />
        </div>
      );
    }
  }

  Enhanced.propTypes = propTypes;
  Enhanced.defaultProps = defaultProps;

  return Enhanced;
};

export default withInfiniteScroll;
